/* eslint-disable no-undef */
import React from 'react'
import { Paper, makeStyles, Grid, Box } from '@material-ui/core'
import ExtraElement from './ExtraElement'

const useStyles = makeStyles(theme => ({
    root: {
        color: theme.termsColor ? theme.termsColor : 'rgba(0, 0, 0, 0.45)',
        textAlign: 'center',
        letterSpacing: 0.5,
        textTransform: 'uppercase',
        fontSize: '0.7rem',
        margin: 'auto'
    },
    paper: {
        background: 'rgba(255,255,255,0.95)',
        boxShadow: '0 3px 5px rgba(0,0,0,0.1)',
        marginTop: theme.spacing(3),
        borderRadius: theme.borderRadius ? theme.borderRadius + 'px!important' : '20px!important',
        [theme.breakpoints.down(600)]: {
            borderRadius: 0 + 'px!important'
        }
    },
    title: {
        fontWeight: 600,
        fontSize: '1.1rem',
        lineHeight: '1.4rem'
    }
}))

function ExtraElements({}) {
    const classes = useStyles()

    return (
        <>
            <Paper className={classes.paper + ' extra-element-paper'} elevation={1}>
                <Box px={{ xs: 2, sm: 3 }} py={3}>
                    <Box className={classes.title + ' extra-element-title'} mb={0.75}>
                        Mietityttääkö osallistuminen?
                    </Box>
                    <Box fontWeight={400}>
                        Se on hyvin järkevää. Anna meidän kuitenkin kertoa, miksi suomalainen LeadSpark Oy (2775435-5) ja sen palvelu Kilpailu.fi
                        ansaitsee luottamuksesi.
                    </Box>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={0.5}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/avainlippu.png'}
                                title={'Olemme 100% suomalainen ja vastuullinen.'}
                                description={'Emme toimita tietojasi kolmansille osapuolille ilman suostumustasi.'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/ssl.png'}
                                title={'Osallistuminen on turvallista ja vie vain minuutin.'}
                                description={'Business Finland tukee tuote&shy;kehitystämme. Kilpailumme ovat tehokkaita ja turvallisia.'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4}>
                            <ExtraElement
                                imageSrc={'/img/asml.png'}
                                title={'ASML valvoo ja kehittää toimintaamme.'}
                                description={'Kaikki toimintamme on Suomen Asiakkuus&shy;markkinointi&shy;liiton tarkistamaa ja ohjaamaa.'}
                            />
                        </Grid>
                    </Grid>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={{ xs: 3, sm: 2.5 }} pt={{ xs: 4, sm: 2.5 }}>
                    <Box fontWeight={400}>
                        Tutustu toimintaamme ja lue meistä lisää osoitteessa:{' '}
                        <a href="https://www.leadspark.fi" target="_blank">
                            LeadSpark.fi
                        </a>
                    </Box>
                </Box>
            </Paper>
            <Paper className={classes.paper + ' extra-element-paper'} elevation={1}>
                <Box px={{ xs: 2, sm: 3 }} py={3}>
                    <Box className={classes.title + ' extra-element-title'} mb={0.75}>
                        Viimeisimmät voittajat
                    </Box>
                    <Box fontWeight={400}>Arvontamme suoritetaan heti kilpailun päätyttyä. Alla viimeisimmät voittajat:</Box>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={0.5}>
                    <Grid container spacing={3}>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 05/2023 - Sähköä 1250€'}
                                description={'<b>Erja H. (Pohjois-Savo)</b><br>31.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Stadium 100 € -lahjakortti'}
                                description={'<b>Päivi K. (Päijät-Häme)</b><br>31.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Stadium 100 € -lahjakortti'}
                                description={'<b>Toini S. (Pohjois-Karjala)</b><br>31.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Vuoden kahvit - 24 pakettia'}
                                description={'<b>Aune M. (Pirkanmaa)</b><br>31.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Väriestejuoksu, 2 lippua'}
                                description={'<b>Heidi R. (Uusimaa)</b><br>14.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Väriestejuoksu, 2 lippua'}
                                description={'<b>Minna L. (Uusimaa)</b><br>14.5.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Holiday Club 250 € -lahjakortti'}
                                description={'<b>Tiina K. (Kymenlaakso)</b><br>30.4.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'1751€ VIP-paketti MM-kisoihin, Suomi-Ruotsi'}
                                description={'<b>Riitta-Maija S. (Uusimaa)</b><br>30.4.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'ExtremeRun - 2 lippua'}
                                description={'<b>Kirsi O. (Päijät-Häme)</b><br>9.4.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'ExtremeRun - 2 lippua'}
                                description={'<b>Noora L. (Keski-Suomi)</b><br>9.4.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kahvi 24 pkt'}
                                description={'<b>Aila A. (Pirkanmaa)</b><br>31.3.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Mökki Rukalta - arvo 1000 €'}
                                description={'<b>Niina T. (Pirkanmaa)</b><br>28.2.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Holiday Club 250 € -lahjakortti'}
                                description={'<b>Taavi R. (Uusimaa)</b><br>14.02.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kellumo-kaverikellunta'}
                                description={'<b>Silja H. (Uusimaa)</b><br>12.2.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Harald-lahjakortti, 120 €'}
                                description={'<b>Jaana T. (Uusimaa)</b><br>12.2.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Särkänniemi kausikortti x 2 - arvo 338€'}
                                description={'<b>Milla T. (Pirkanmaa)</b><br>15.1.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 1/2023 - 1200€ sähköä'}
                                description={'<b>Jouko L. (Päijät-Häme)</b><br>31.1.2023'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 12/2022 - 1000€ sähköä'}
                                description={'<b>Helena P. (Varsinais-Suomi)</b><br>31.12.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'BookBeat Premium 6kk'}
                                description={'<b>Eeva L. (Pirkanmaa)</b><br>20.12.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'200€ Joulurahaa'}
                                description={'<b>Aila R. (Kanta-Häme)</b><br>19.12.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Viikinkiravintola Harald - Haraldin ja Helgan rakkauspaketti - arvo 120€'}
                                description={'<b>Jani H. (Uusimaa)</b><br>15.12.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 11/2022 - 1050€ sähköä'}
                                description={'<b>Pirkko T. (Etelä-Savo)</b><br>30.11.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'200 € Black Friday -rahaa'}
                                description={'<b>Janne T. (Satakunta)</b><br>24.11.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 10/2022 - 1100€ sähköä'}
                                description={'<b>Outi N. (Lappi)</b><br>31.10.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Moccamaster Optio Gold -keitin'}
                                description={'<b>Aino S. (Uusimaa)</b><br>25.10.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Särkänniemi Karmiva Karnevaali'}
                                description={'<b>Harri A. (Pohjois-Savo)</b><br>11.10.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Biorex sarjalippu'}
                                description={'<b>Vili K. (Keski-Pohjanmaa)</b><br>30.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Biorex sarjalippu'}
                                description={'<b>Elina H. (Keski-Suomi)</b><br>30.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Biorex sarjalippu'}
                                description={'<b>Hugo H. (Uusimaa)</b><br>30.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 09/2022 - 1000€ sähkölaskuihin'}
                                description={'<b>Arja A. (Pohjois-Pohjanmaa)</b><br>30.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Holiday Club 250€ -lahjakortti haluamaasi kohteeseen'}
                                description={'<b>Antti K. (Pohjois-Pohjanmaa)</b><br>25.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Novita 60€'}
                                description={'<b>Päivi P. (Pohjois-Pohjanmaa)</b><br>14.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Novita 60€'}
                                description={'<b>Marita M. (Satakunta)</b><br>14.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Novita 60€'}
                                description={'<b>Tarja N. (Varsinais-Suomi)</b><br>14.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Elämyslahjat 250€'}
                                description={'<b>Anniina K. (Pohjois-Pohjanmaa)</b><br>14.9.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Sähkötutkimus 08/2022 - Vuoden Sähköt (arvo 1200€)'}
                                description={'<b>Leena R. (Huittinen)</b><br>31.8.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Fitnesstukku 100€'}
                                description={'<b>Saija M. (Varsinais-Suomi)</b><br>31.8.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Fitnesstukku 100€'}
                                description={'<b>Aram N. (Uusimaa)</b><br>31.8.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Fitnesstukku 100€'}
                                description={'<b>Sara Y. (Pirkanmaa)</b><br>31.8.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Ekologinen kahvisetti - 31.7.2022'}
                                description={'<b>Jenni K. (Turku)</b>: <i>“Mukavaa, että välillä onni osuu kohdalle!”</i>'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'6kg kahvia - 30.7.2022'}
                                description={
                                    '<b>Selina K. (Kajaani)</b>: <i>“Mahtavaltahan se tuntui ottaen huomioon nykyisen kahvin hinnan. Kiitos. Lähetystä odottaen.”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kesäpäivä Porvoossa kahdelle - 20.7.2022'}
                                description={
                                    '<b>Tytti S. (Jyväskylä)</b>: <i>“Olen ollut Porvoossa, mutta matka höyrylaivalla saariston läpi on ihan erityistä. Luin uutisen voitosta heti kahteen kertaan ja ajattelin “onpa kiva kesäreissu kahdelle tulossa”. Mukava yllätys.”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'4 ranneketta ja 4 herkkuseteliä Särkänniemeen - 20.7.2022'}
                                description={
                                    '<b>Sanna A. (Helsinki)</b>: <i>“Voitto tuntui poikkeuksellisen hyvältä! Mukava päästä Särkänniemeen viettämään aikaa ja hurvittelemaan perheen kesken! Lapset eivät malta pysyä housuissaan voitto-uutisen jälkeen.”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kesärahaa 1000€'}
                                description={'<b>Eetu J. (Alajärvi)</b><br>31.6.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Särkänniemi-lippupaketti, 250€'}
                                description={'<b>Adele O.</b><br>16.6.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Tuotepaketti saunatuotteita, 158€'}
                                description={'<b>Helkky H.</b><br>13.6.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Tankillinen polttoainetta, 150€'}
                                description={'<b>Pirkko L. (Tampere)</b><br>1.6.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'200€ Vappurahaa - 1.5.2022'}
                                description={'<b>Jussi J. (Inkeroinen)</b>: <i>“Aivan mahtavaa voittaa joskus jotain kiitos vappuarvonta”</i>'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'2x24-pack NOCCOa - 30.4.2022'}
                                description={
                                    '<b>Tiiu K. (Kymenlaakso)</b>: <i>“Voittaminen tuli aivan yllätyksenä, mutta oli erittäin positiivinen yllätys! Piristi päivää mukavasti!”</i>'
                                }
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'PlayStation 5 -pelikonsoli'}
                                description={'<b>Seija H. (Pohjois-Pohjanmaa)</b><br>30.4.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Kahvit vuodeksi'}
                                description={'<b>Teuvo K. (Uusimaa)</b><br>31.3.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Vuoden pääpalkinto, 1000€'}
                                description={'<b>Auli P. (Etelä-Savo)</b><br>1.1.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Uudenvuoden arvonta, 200€'}
                                description={'<b>Keijo S (Uusimaa)</b><br>1.1.2022'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'Jouluarvonta, 200€'}
                                description={'<b>Eero V. (Pohjois-Pohjanmaa)</b><br>21.12.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <ExtraElement
                                smallImageSrc={'/img/winner-placeholder.png'}
                                title={'2. Black Friday -arvonta, 200€'}
                                description={'<b>Marko R. (Varsinais-Suomi)</b><br>26.11.2021'}
                            />
                        </Grid>
                        <Grid item xs={12} sm={12}>
                            <ExtraElement
                                smallImageSrc={'/img/winner1.png'}
                                title={'1000€ Matkalahjakortti haluamaasi kohteeseen kotimaassa - 1.9.2021'}
                                description={
                                    '<b>Outi T. (Uusimaa)</b>: <i>Kun sain puhelun voitosta, olin ensin epäuskoinen ja kuvittelin joutuneeni huijauksen kohteeksi. Mutta kun voittosumma tuli tililleni, oli minunkin pakko uskoa: “Kerrankin minä, jee!”</i>'
                                }
                            />
                        </Grid>
                        {false && (
                            <>
                                <Grid item xs={12} sm={6}>
                                    <ExtraElement
                                        smallImageSrc={'/img/winner-placeholder.png'}
                                        title={'Netflix-lahjakortti koko vuodeksi'}
                                        description={'<b>Saila K. (Lahti)</b><br>15.8.2021'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <ExtraElement
                                        smallImageSrc={'/img/winner-placeholder.png'}
                                        title={'Samsung Galaxy S20 5G 128gt'}
                                        description={'<b>Sinikka P. (Hämeenlinna)</b><br>31.6.2021'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <ExtraElement
                                        smallImageSrc={'/img/winner-placeholder.png'}
                                        title={'1000€ Paljujuhannus tarjoiluineen'}
                                        description={'<b>Kati P. (Oulu)</b><br>1.6.2021'}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <ExtraElement
                                        smallImageSrc={'/img/winner-placeholder.png'}
                                        title={'250€ Saunailta MM-kisäeväineen'}
                                        description={'<b>Liisa R. (Pohjois-Pohjanmaa)</b><br>1.5.2021'}
                                    />
                                </Grid>
                            </>
                        )}
                    </Grid>
                </Box>
                <Box px={{ xs: 2, sm: 3 }} pb={{ xs: 3, sm: 2.5 }} pt={{ xs: 4, sm: 2.5 }}>
                    <Box fontWeight={400}>
                        <a href="https://www.kilpailu.fi/fi/voittajat/" target="_blank">
                            Katso lisää voittajia
                        </a>
                    </Box>
                </Box>
            </Paper>
        </>
    )
}

export default ExtraElements
